<div class="ws-popup-header">
    <span *ngIf="isWarning">{{ "Attention!" | translate }}</span>
  <div class="actions">
      <button (click)="closeClicked()" mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<div class="ws-popup-content">
  <div class="ws-popup-body">
    <div class="description-wrapper">
      <p class="bold" [innerHTML]="text | translate"></p>
      <p *ngFor="let item of items">
        <span [innerHTML]="item"></span>
      </p>
    </div>
  </div>
</div>